/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Motivation_LongInputs */

const en_us2_intake_why_motivation_long = /** @type {(inputs: Intake_Why_Motivation_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your reason changes how the trainer talks to you. It never changes a set or a load.`)
};

const pt_br2_intake_why_motivation_long = /** @type {(inputs: Intake_Why_Motivation_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu motivo muda como o treinador fala com você. Nunca muda uma série ou carga.`)
};

const es_419_intake_why_motivation_long = /** @type {(inputs: Intake_Why_Motivation_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu motivo cambia cómo te habla el entrenador. Nunca cambia una serie ni una carga.`)
};

const pt_pt2_intake_why_motivation_long = /** @type {(inputs: Intake_Why_Motivation_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu motivo muda a forma como o treinador fala contigo. Nunca muda uma série nem uma carga.`)
};

const fr_fr2_intake_why_motivation_long = /** @type {(inputs: Intake_Why_Motivation_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta raison change la façon dont le coach te parle. Elle ne change jamais une série ni une charge.`)
};

const de_de2_intake_why_motivation_long = /** @type {(inputs: Intake_Why_Motivation_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Grund verändert, wie der Coach mit dir spricht. Er ändert nie einen Satz oder ein Gewicht.`)
};

const it_it2_intake_why_motivation_long = /** @type {(inputs: Intake_Why_Motivation_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo motivo cambia il modo in cui il coach ti parla. Non cambia mai una serie o un carico.`)
};

/**
* | output |
* | --- |
* | "Your reason changes how the trainer talks to you. It never changes a set or a load." |
*
* @param {Intake_Why_Motivation_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_motivation_long = /** @type {((inputs?: Intake_Why_Motivation_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Motivation_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_motivation_long(inputs)
	if (locale === "es-419") return es_419_intake_why_motivation_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_motivation_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_motivation_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_motivation_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_motivation_long(inputs)
	return en_us2_intake_why_motivation_long(inputs)
});
export { intake_why_motivation_long as "intake.why.motivation.long" }